/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Type_CharacterInputs */



/**
* | output |
* | --- |
* | "Character" |
*
* @param {Knp_Lookup_Type_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_type_character = /** @type {((inputs?: Knp_Lookup_Type_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Type_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personnage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Charakter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Характер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Personaje")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("特点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャラクター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चरित्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personagem")
	return /** @type {LocalizedString} */ ("Character")
});